import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    paginationContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        marginTop: "auto"
    },
    modalActions: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    modalOverlay: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    itemIcon: {
        justifyContent: "center",
        alignItems: "center",
        height: 48,
        width: 48
    },
    itemContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    itemActions: {
        flexDirection: "row",
        alignItems: "center"
    },
    itemContent: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    permissionsContainer: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    checkboxRow: {
        flexDirection: "row",
        alignItems: "center"
    },
    paginationButtons: {
        flexDirection: "row"
    },
    permissionsScroll: {
    },
    permissionsTitle: {
    },
    permissionBadge: {
    },
    paginationInfo: {
        flex: 1
    },
    formContainer: {
    },
    modalContent: {
        width: 500
    },
    listContent: {
    },
    searchInput: {
    },
    container: {
        flex: 1
    },
    itemInfo: {
        flex: 1
    }
});
export default stylesheet;
